/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RangeHealthRouteImport } from './routes/range-health'
import { Route as MonitoringRouteImport } from './routes/monitoring'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DevLoginRouteImport } from './routes/dev-login'
import { Route as CostRouteImport } from './routes/cost'
import { Route as BuilderRouteImport } from './routes/builder'
import { Route as AttackNavigatorRouteImport } from './routes/attack-navigator'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TraineeIndexRouteImport } from './routes/trainee.index'
import { Route as ScenariosIndexRouteImport } from './routes/scenarios.index'
import { Route as RangesIndexRouteImport } from './routes/ranges.index'
import { Route as LabsIndexRouteImport } from './routes/labs.index'
import { Route as InstructorIndexRouteImport } from './routes/instructor.index'
import { Route as CoursesIndexRouteImport } from './routes/courses.index'
import { Route as BlueprintsIndexRouteImport } from './routes/blueprints.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as TraineeRangeIdRouteImport } from './routes/trainee.$rangeId'
import { Route as ScenariosSlugRouteImport } from './routes/scenarios.$slug'
import { Route as RangesIdRouteImport } from './routes/ranges.$id'
import { Route as LabsIdRouteImport } from './routes/labs.$id'
import { Route as JourneyResultRouteImport } from './routes/journey.result'
import { Route as JourneyPlacementRouteImport } from './routes/journey.placement'
import { Route as InstructorUsersRouteImport } from './routes/instructor.users'
import { Route as InstructorOrganizationRouteImport } from './routes/instructor.organization'
import { Route as CoursesIdRouteImport } from './routes/courses.$id'
import { Route as BlueprintsSlugRouteImport } from './routes/blueprints.$slug'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminTenantsRouteImport } from './routes/admin.tenants'
import { Route as AdminReviewRouteImport } from './routes/admin.review'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as InstructorCohortsIndexRouteImport } from './routes/instructor.cohorts.index'
import { Route as CoursesIdIndexRouteImport } from './routes/courses.$id.index'
import { Route as AdminGradebookIndexRouteImport } from './routes/admin.gradebook.index'
import { Route as AdminCohortsIndexRouteImport } from './routes/admin.cohorts.index'
import { Route as RangesIdSocRouteImport } from './routes/ranges.$id.soc'
import { Route as CoursesSlugModuleRouteImport } from './routes/courses.$slug.$module'
import { Route as ConsoleRangeIdVmNameRouteImport } from './routes/console.$rangeId.$vmName'
import { Route as AdminTenantsTenantIdRouteImport } from './routes/admin.tenants_.$tenantId'
import { Route as InstructorCohortsIdEnrollRouteImport } from './routes/instructor.cohorts.$id.enroll'
import { Route as CoursesIdTopicTopicRouteImport } from './routes/courses.$id.topic.$topic'
import { Route as AdminGradebookCohortIdReportRouteImport } from './routes/admin.gradebook.$cohortId.report'
import { Route as AdminGradebookCohortIdUserIdRouteImport } from './routes/admin.gradebook.$cohortId.$userId'
import { Route as AdminCohortsIdEnrollRouteImport } from './routes/admin.cohorts.$id.enroll'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RangeHealthRoute = RangeHealthRouteImport.update({
  id: '/range-health',
  path: '/range-health',
  getParentRoute: () => rootRouteImport,
} as any)
const MonitoringRoute = MonitoringRouteImport.update({
  id: '/monitoring',
  path: '/monitoring',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardRoute = LeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DevLoginRoute = DevLoginRouteImport.update({
  id: '/dev-login',
  path: '/dev-login',
  getParentRoute: () => rootRouteImport,
} as any)
const CostRoute = CostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => rootRouteImport,
} as any)
const BuilderRoute = BuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => rootRouteImport,
} as any)
const AttackNavigatorRoute = AttackNavigatorRouteImport.update({
  id: '/attack-navigator',
  path: '/attack-navigator',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TraineeIndexRoute = TraineeIndexRouteImport.update({
  id: '/trainee/',
  path: '/trainee/',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenariosIndexRoute = ScenariosIndexRouteImport.update({
  id: '/scenarios/',
  path: '/scenarios/',
  getParentRoute: () => rootRouteImport,
} as any)
const RangesIndexRoute = RangesIndexRouteImport.update({
  id: '/ranges/',
  path: '/ranges/',
  getParentRoute: () => rootRouteImport,
} as any)
const LabsIndexRoute = LabsIndexRouteImport.update({
  id: '/labs/',
  path: '/labs/',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorIndexRoute = InstructorIndexRouteImport.update({
  id: '/instructor/',
  path: '/instructor/',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesIndexRoute = CoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlueprintsIndexRoute = BlueprintsIndexRouteImport.update({
  id: '/blueprints/',
  path: '/blueprints/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const TraineeRangeIdRoute = TraineeRangeIdRouteImport.update({
  id: '/trainee/$rangeId',
  path: '/trainee/$rangeId',
  getParentRoute: () => rootRouteImport,
} as any)
const ScenariosSlugRoute = ScenariosSlugRouteImport.update({
  id: '/scenarios/$slug',
  path: '/scenarios/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const RangesIdRoute = RangesIdRouteImport.update({
  id: '/ranges/$id',
  path: '/ranges/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LabsIdRoute = LabsIdRouteImport.update({
  id: '/labs/$id',
  path: '/labs/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const JourneyResultRoute = JourneyResultRouteImport.update({
  id: '/journey/result',
  path: '/journey/result',
  getParentRoute: () => rootRouteImport,
} as any)
const JourneyPlacementRoute = JourneyPlacementRouteImport.update({
  id: '/journey/placement',
  path: '/journey/placement',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorUsersRoute = InstructorUsersRouteImport.update({
  id: '/instructor/users',
  path: '/instructor/users',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorOrganizationRoute = InstructorOrganizationRouteImport.update({
  id: '/instructor/organization',
  path: '/instructor/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesIdRoute = CoursesIdRouteImport.update({
  id: '/courses/$id',
  path: '/courses/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BlueprintsSlugRoute = BlueprintsSlugRouteImport.update({
  id: '/blueprints/$slug',
  path: '/blueprints/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsRoute = AdminTenantsRouteImport.update({
  id: '/admin/tenants',
  path: '/admin/tenants',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReviewRoute = AdminReviewRouteImport.update({
  id: '/admin/review',
  path: '/admin/review',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorCohortsIndexRoute = InstructorCohortsIndexRouteImport.update({
  id: '/instructor/cohorts/',
  path: '/instructor/cohorts/',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesIdIndexRoute = CoursesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CoursesIdRoute,
} as any)
const AdminGradebookIndexRoute = AdminGradebookIndexRouteImport.update({
  id: '/admin/gradebook/',
  path: '/admin/gradebook/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCohortsIndexRoute = AdminCohortsIndexRouteImport.update({
  id: '/admin/cohorts/',
  path: '/admin/cohorts/',
  getParentRoute: () => rootRouteImport,
} as any)
const RangesIdSocRoute = RangesIdSocRouteImport.update({
  id: '/soc',
  path: '/soc',
  getParentRoute: () => RangesIdRoute,
} as any)
const CoursesSlugModuleRoute = CoursesSlugModuleRouteImport.update({
  id: '/courses/$slug/$module',
  path: '/courses/$slug/$module',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsoleRangeIdVmNameRoute = ConsoleRangeIdVmNameRouteImport.update({
  id: '/console/$rangeId/$vmName',
  path: '/console/$rangeId/$vmName',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsTenantIdRoute = AdminTenantsTenantIdRouteImport.update({
  id: '/admin/tenants_/$tenantId',
  path: '/admin/tenants/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorCohortsIdEnrollRoute =
  InstructorCohortsIdEnrollRouteImport.update({
    id: '/instructor/cohorts/$id/enroll',
    path: '/instructor/cohorts/$id/enroll',
    getParentRoute: () => rootRouteImport,
  } as any)
const CoursesIdTopicTopicRoute = CoursesIdTopicTopicRouteImport.update({
  id: '/topic/$topic',
  path: '/topic/$topic',
  getParentRoute: () => CoursesIdRoute,
} as any)
const AdminGradebookCohortIdReportRoute =
  AdminGradebookCohortIdReportRouteImport.update({
    id: '/admin/gradebook/$cohortId/report',
    path: '/admin/gradebook/$cohortId/report',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminGradebookCohortIdUserIdRoute =
  AdminGradebookCohortIdUserIdRouteImport.update({
    id: '/admin/gradebook/$cohortId/$userId',
    path: '/admin/gradebook/$cohortId/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCohortsIdEnrollRoute = AdminCohortsIdEnrollRouteImport.update({
  id: '/admin/cohorts/$id/enroll',
  path: '/admin/cohorts/$id/enroll',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/attack-navigator': typeof AttackNavigatorRoute
  '/builder': typeof BuilderRoute
  '/cost': typeof CostRoute
  '/dev-login': typeof DevLoginRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/monitoring': typeof MonitoringRoute
  '/range-health': typeof RangeHealthRoute
  '/settings': typeof SettingsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/review': typeof AdminReviewRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blueprints/$slug': typeof BlueprintsSlugRoute
  '/courses/$id': typeof CoursesIdRouteWithChildren
  '/instructor/organization': typeof InstructorOrganizationRoute
  '/instructor/users': typeof InstructorUsersRoute
  '/journey/placement': typeof JourneyPlacementRoute
  '/journey/result': typeof JourneyResultRoute
  '/labs/$id': typeof LabsIdRoute
  '/ranges/$id': typeof RangesIdRouteWithChildren
  '/scenarios/$slug': typeof ScenariosSlugRoute
  '/trainee/$rangeId': typeof TraineeRangeIdRoute
  '/admin/': typeof AdminIndexRoute
  '/blueprints/': typeof BlueprintsIndexRoute
  '/courses/': typeof CoursesIndexRoute
  '/instructor/': typeof InstructorIndexRoute
  '/labs/': typeof LabsIndexRoute
  '/ranges/': typeof RangesIndexRoute
  '/scenarios/': typeof ScenariosIndexRoute
  '/trainee/': typeof TraineeIndexRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdRoute
  '/console/$rangeId/$vmName': typeof ConsoleRangeIdVmNameRoute
  '/courses/$slug/$module': typeof CoursesSlugModuleRoute
  '/ranges/$id/soc': typeof RangesIdSocRoute
  '/admin/cohorts/': typeof AdminCohortsIndexRoute
  '/admin/gradebook/': typeof AdminGradebookIndexRoute
  '/courses/$id/': typeof CoursesIdIndexRoute
  '/instructor/cohorts/': typeof InstructorCohortsIndexRoute
  '/admin/cohorts/$id/enroll': typeof AdminCohortsIdEnrollRoute
  '/admin/gradebook/$cohortId/$userId': typeof AdminGradebookCohortIdUserIdRoute
  '/admin/gradebook/$cohortId/report': typeof AdminGradebookCohortIdReportRoute
  '/courses/$id/topic/$topic': typeof CoursesIdTopicTopicRoute
  '/instructor/cohorts/$id/enroll': typeof InstructorCohortsIdEnrollRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/attack-navigator': typeof AttackNavigatorRoute
  '/builder': typeof BuilderRoute
  '/cost': typeof CostRoute
  '/dev-login': typeof DevLoginRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/monitoring': typeof MonitoringRoute
  '/range-health': typeof RangeHealthRoute
  '/settings': typeof SettingsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/review': typeof AdminReviewRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blueprints/$slug': typeof BlueprintsSlugRoute
  '/instructor/organization': typeof InstructorOrganizationRoute
  '/instructor/users': typeof InstructorUsersRoute
  '/journey/placement': typeof JourneyPlacementRoute
  '/journey/result': typeof JourneyResultRoute
  '/labs/$id': typeof LabsIdRoute
  '/ranges/$id': typeof RangesIdRouteWithChildren
  '/scenarios/$slug': typeof ScenariosSlugRoute
  '/trainee/$rangeId': typeof TraineeRangeIdRoute
  '/admin': typeof AdminIndexRoute
  '/blueprints': typeof BlueprintsIndexRoute
  '/courses': typeof CoursesIndexRoute
  '/instructor': typeof InstructorIndexRoute
  '/labs': typeof LabsIndexRoute
  '/ranges': typeof RangesIndexRoute
  '/scenarios': typeof ScenariosIndexRoute
  '/trainee': typeof TraineeIndexRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdRoute
  '/console/$rangeId/$vmName': typeof ConsoleRangeIdVmNameRoute
  '/courses/$slug/$module': typeof CoursesSlugModuleRoute
  '/ranges/$id/soc': typeof RangesIdSocRoute
  '/admin/cohorts': typeof AdminCohortsIndexRoute
  '/admin/gradebook': typeof AdminGradebookIndexRoute
  '/courses/$id': typeof CoursesIdIndexRoute
  '/instructor/cohorts': typeof InstructorCohortsIndexRoute
  '/admin/cohorts/$id/enroll': typeof AdminCohortsIdEnrollRoute
  '/admin/gradebook/$cohortId/$userId': typeof AdminGradebookCohortIdUserIdRoute
  '/admin/gradebook/$cohortId/report': typeof AdminGradebookCohortIdReportRoute
  '/courses/$id/topic/$topic': typeof CoursesIdTopicTopicRoute
  '/instructor/cohorts/$id/enroll': typeof InstructorCohortsIdEnrollRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/attack-navigator': typeof AttackNavigatorRoute
  '/builder': typeof BuilderRoute
  '/cost': typeof CostRoute
  '/dev-login': typeof DevLoginRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/leaderboard': typeof LeaderboardRoute
  '/login': typeof LoginRoute
  '/monitoring': typeof MonitoringRoute
  '/range-health': typeof RangeHealthRoute
  '/settings': typeof SettingsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/review': typeof AdminReviewRoute
  '/admin/tenants': typeof AdminTenantsRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/blueprints/$slug': typeof BlueprintsSlugRoute
  '/courses/$id': typeof CoursesIdRouteWithChildren
  '/instructor/organization': typeof InstructorOrganizationRoute
  '/instructor/users': typeof InstructorUsersRoute
  '/journey/placement': typeof JourneyPlacementRoute
  '/journey/result': typeof JourneyResultRoute
  '/labs/$id': typeof LabsIdRoute
  '/ranges/$id': typeof RangesIdRouteWithChildren
  '/scenarios/$slug': typeof ScenariosSlugRoute
  '/trainee/$rangeId': typeof TraineeRangeIdRoute
  '/admin/': typeof AdminIndexRoute
  '/blueprints/': typeof BlueprintsIndexRoute
  '/courses/': typeof CoursesIndexRoute
  '/instructor/': typeof InstructorIndexRoute
  '/labs/': typeof LabsIndexRoute
  '/ranges/': typeof RangesIndexRoute
  '/scenarios/': typeof ScenariosIndexRoute
  '/trainee/': typeof TraineeIndexRoute
  '/admin/tenants_/$tenantId': typeof AdminTenantsTenantIdRoute
  '/console/$rangeId/$vmName': typeof ConsoleRangeIdVmNameRoute
  '/courses/$slug/$module': typeof CoursesSlugModuleRoute
  '/ranges/$id/soc': typeof RangesIdSocRoute
  '/admin/cohorts/': typeof AdminCohortsIndexRoute
  '/admin/gradebook/': typeof AdminGradebookIndexRoute
  '/courses/$id/': typeof CoursesIdIndexRoute
  '/instructor/cohorts/': typeof InstructorCohortsIndexRoute
  '/admin/cohorts/$id/enroll': typeof AdminCohortsIdEnrollRoute
  '/admin/gradebook/$cohortId/$userId': typeof AdminGradebookCohortIdUserIdRoute
  '/admin/gradebook/$cohortId/report': typeof AdminGradebookCohortIdReportRoute
  '/courses/$id/topic/$topic': typeof CoursesIdTopicTopicRoute
  '/instructor/cohorts/$id/enroll': typeof InstructorCohortsIdEnrollRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/attack-navigator'
    | '/builder'
    | '/cost'
    | '/dev-login'
    | '/forgot-password'
    | '/leaderboard'
    | '/login'
    | '/monitoring'
    | '/range-health'
    | '/settings'
    | '/admin/audit'
    | '/admin/review'
    | '/admin/tenants'
    | '/admin/users'
    | '/auth/callback'
    | '/blueprints/$slug'
    | '/courses/$id'
    | '/instructor/organization'
    | '/instructor/users'
    | '/journey/placement'
    | '/journey/result'
    | '/labs/$id'
    | '/ranges/$id'
    | '/scenarios/$slug'
    | '/trainee/$rangeId'
    | '/admin/'
    | '/blueprints/'
    | '/courses/'
    | '/instructor/'
    | '/labs/'
    | '/ranges/'
    | '/scenarios/'
    | '/trainee/'
    | '/admin/tenants/$tenantId'
    | '/console/$rangeId/$vmName'
    | '/courses/$slug/$module'
    | '/ranges/$id/soc'
    | '/admin/cohorts/'
    | '/admin/gradebook/'
    | '/courses/$id/'
    | '/instructor/cohorts/'
    | '/admin/cohorts/$id/enroll'
    | '/admin/gradebook/$cohortId/$userId'
    | '/admin/gradebook/$cohortId/report'
    | '/courses/$id/topic/$topic'
    | '/instructor/cohorts/$id/enroll'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/attack-navigator'
    | '/builder'
    | '/cost'
    | '/dev-login'
    | '/forgot-password'
    | '/leaderboard'
    | '/login'
    | '/monitoring'
    | '/range-health'
    | '/settings'
    | '/admin/audit'
    | '/admin/review'
    | '/admin/tenants'
    | '/admin/users'
    | '/auth/callback'
    | '/blueprints/$slug'
    | '/instructor/organization'
    | '/instructor/users'
    | '/journey/placement'
    | '/journey/result'
    | '/labs/$id'
    | '/ranges/$id'
    | '/scenarios/$slug'
    | '/trainee/$rangeId'
    | '/admin'
    | '/blueprints'
    | '/courses'
    | '/instructor'
    | '/labs'
    | '/ranges'
    | '/scenarios'
    | '/trainee'
    | '/admin/tenants/$tenantId'
    | '/console/$rangeId/$vmName'
    | '/courses/$slug/$module'
    | '/ranges/$id/soc'
    | '/admin/cohorts'
    | '/admin/gradebook'
    | '/courses/$id'
    | '/instructor/cohorts'
    | '/admin/cohorts/$id/enroll'
    | '/admin/gradebook/$cohortId/$userId'
    | '/admin/gradebook/$cohortId/report'
    | '/courses/$id/topic/$topic'
    | '/instructor/cohorts/$id/enroll'
  id:
    | '__root__'
    | '/'
    | '/attack-navigator'
    | '/builder'
    | '/cost'
    | '/dev-login'
    | '/forgot-password'
    | '/leaderboard'
    | '/login'
    | '/monitoring'
    | '/range-health'
    | '/settings'
    | '/admin/audit'
    | '/admin/review'
    | '/admin/tenants'
    | '/admin/users'
    | '/auth/callback'
    | '/blueprints/$slug'
    | '/courses/$id'
    | '/instructor/organization'
    | '/instructor/users'
    | '/journey/placement'
    | '/journey/result'
    | '/labs/$id'
    | '/ranges/$id'
    | '/scenarios/$slug'
    | '/trainee/$rangeId'
    | '/admin/'
    | '/blueprints/'
    | '/courses/'
    | '/instructor/'
    | '/labs/'
    | '/ranges/'
    | '/scenarios/'
    | '/trainee/'
    | '/admin/tenants_/$tenantId'
    | '/console/$rangeId/$vmName'
    | '/courses/$slug/$module'
    | '/ranges/$id/soc'
    | '/admin/cohorts/'
    | '/admin/gradebook/'
    | '/courses/$id/'
    | '/instructor/cohorts/'
    | '/admin/cohorts/$id/enroll'
    | '/admin/gradebook/$cohortId/$userId'
    | '/admin/gradebook/$cohortId/report'
    | '/courses/$id/topic/$topic'
    | '/instructor/cohorts/$id/enroll'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AttackNavigatorRoute: typeof AttackNavigatorRoute
  BuilderRoute: typeof BuilderRoute
  CostRoute: typeof CostRoute
  DevLoginRoute: typeof DevLoginRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LeaderboardRoute: typeof LeaderboardRoute
  LoginRoute: typeof LoginRoute
  MonitoringRoute: typeof MonitoringRoute
  RangeHealthRoute: typeof RangeHealthRoute
  SettingsRoute: typeof SettingsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminReviewRoute: typeof AdminReviewRoute
  AdminTenantsRoute: typeof AdminTenantsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  BlueprintsSlugRoute: typeof BlueprintsSlugRoute
  CoursesIdRoute: typeof CoursesIdRouteWithChildren
  InstructorOrganizationRoute: typeof InstructorOrganizationRoute
  InstructorUsersRoute: typeof InstructorUsersRoute
  JourneyPlacementRoute: typeof JourneyPlacementRoute
  JourneyResultRoute: typeof JourneyResultRoute
  LabsIdRoute: typeof LabsIdRoute
  RangesIdRoute: typeof RangesIdRouteWithChildren
  ScenariosSlugRoute: typeof ScenariosSlugRoute
  TraineeRangeIdRoute: typeof TraineeRangeIdRoute
  AdminIndexRoute: typeof AdminIndexRoute
  BlueprintsIndexRoute: typeof BlueprintsIndexRoute
  CoursesIndexRoute: typeof CoursesIndexRoute
  InstructorIndexRoute: typeof InstructorIndexRoute
  LabsIndexRoute: typeof LabsIndexRoute
  RangesIndexRoute: typeof RangesIndexRoute
  ScenariosIndexRoute: typeof ScenariosIndexRoute
  TraineeIndexRoute: typeof TraineeIndexRoute
  AdminTenantsTenantIdRoute: typeof AdminTenantsTenantIdRoute
  ConsoleRangeIdVmNameRoute: typeof ConsoleRangeIdVmNameRoute
  CoursesSlugModuleRoute: typeof CoursesSlugModuleRoute
  AdminCohortsIndexRoute: typeof AdminCohortsIndexRoute
  AdminGradebookIndexRoute: typeof AdminGradebookIndexRoute
  InstructorCohortsIndexRoute: typeof InstructorCohortsIndexRoute
  AdminCohortsIdEnrollRoute: typeof AdminCohortsIdEnrollRoute
  AdminGradebookCohortIdUserIdRoute: typeof AdminGradebookCohortIdUserIdRoute
  AdminGradebookCohortIdReportRoute: typeof AdminGradebookCohortIdReportRoute
  InstructorCohortsIdEnrollRoute: typeof InstructorCohortsIdEnrollRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/range-health': {
      id: '/range-health'
      path: '/range-health'
      fullPath: '/range-health'
      preLoaderRoute: typeof RangeHealthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/monitoring': {
      id: '/monitoring'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof MonitoringRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev-login': {
      id: '/dev-login'
      path: '/dev-login'
      fullPath: '/dev-login'
      preLoaderRoute: typeof DevLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cost': {
      id: '/cost'
      path: '/cost'
      fullPath: '/cost'
      preLoaderRoute: typeof CostRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builder': {
      id: '/builder'
      path: '/builder'
      fullPath: '/builder'
      preLoaderRoute: typeof BuilderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attack-navigator': {
      id: '/attack-navigator'
      path: '/attack-navigator'
      fullPath: '/attack-navigator'
      preLoaderRoute: typeof AttackNavigatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trainee/': {
      id: '/trainee/'
      path: '/trainee'
      fullPath: '/trainee/'
      preLoaderRoute: typeof TraineeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenarios/': {
      id: '/scenarios/'
      path: '/scenarios'
      fullPath: '/scenarios/'
      preLoaderRoute: typeof ScenariosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ranges/': {
      id: '/ranges/'
      path: '/ranges'
      fullPath: '/ranges/'
      preLoaderRoute: typeof RangesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labs/': {
      id: '/labs/'
      path: '/labs'
      fullPath: '/labs/'
      preLoaderRoute: typeof LabsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/': {
      id: '/instructor/'
      path: '/instructor'
      fullPath: '/instructor/'
      preLoaderRoute: typeof InstructorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/': {
      id: '/courses/'
      path: '/courses'
      fullPath: '/courses/'
      preLoaderRoute: typeof CoursesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blueprints/': {
      id: '/blueprints/'
      path: '/blueprints'
      fullPath: '/blueprints/'
      preLoaderRoute: typeof BlueprintsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trainee/$rangeId': {
      id: '/trainee/$rangeId'
      path: '/trainee/$rangeId'
      fullPath: '/trainee/$rangeId'
      preLoaderRoute: typeof TraineeRangeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scenarios/$slug': {
      id: '/scenarios/$slug'
      path: '/scenarios/$slug'
      fullPath: '/scenarios/$slug'
      preLoaderRoute: typeof ScenariosSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ranges/$id': {
      id: '/ranges/$id'
      path: '/ranges/$id'
      fullPath: '/ranges/$id'
      preLoaderRoute: typeof RangesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labs/$id': {
      id: '/labs/$id'
      path: '/labs/$id'
      fullPath: '/labs/$id'
      preLoaderRoute: typeof LabsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journey/result': {
      id: '/journey/result'
      path: '/journey/result'
      fullPath: '/journey/result'
      preLoaderRoute: typeof JourneyResultRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/journey/placement': {
      id: '/journey/placement'
      path: '/journey/placement'
      fullPath: '/journey/placement'
      preLoaderRoute: typeof JourneyPlacementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/users': {
      id: '/instructor/users'
      path: '/instructor/users'
      fullPath: '/instructor/users'
      preLoaderRoute: typeof InstructorUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/organization': {
      id: '/instructor/organization'
      path: '/instructor/organization'
      fullPath: '/instructor/organization'
      preLoaderRoute: typeof InstructorOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/$id': {
      id: '/courses/$id'
      path: '/courses/$id'
      fullPath: '/courses/$id'
      preLoaderRoute: typeof CoursesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blueprints/$slug': {
      id: '/blueprints/$slug'
      path: '/blueprints/$slug'
      fullPath: '/blueprints/$slug'
      preLoaderRoute: typeof BlueprintsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants': {
      id: '/admin/tenants'
      path: '/admin/tenants'
      fullPath: '/admin/tenants'
      preLoaderRoute: typeof AdminTenantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/review': {
      id: '/admin/review'
      path: '/admin/review'
      fullPath: '/admin/review'
      preLoaderRoute: typeof AdminReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/cohorts/': {
      id: '/instructor/cohorts/'
      path: '/instructor/cohorts'
      fullPath: '/instructor/cohorts/'
      preLoaderRoute: typeof InstructorCohortsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/$id/': {
      id: '/courses/$id/'
      path: '/'
      fullPath: '/courses/$id/'
      preLoaderRoute: typeof CoursesIdIndexRouteImport
      parentRoute: typeof CoursesIdRoute
    }
    '/admin/gradebook/': {
      id: '/admin/gradebook/'
      path: '/admin/gradebook'
      fullPath: '/admin/gradebook/'
      preLoaderRoute: typeof AdminGradebookIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/cohorts/': {
      id: '/admin/cohorts/'
      path: '/admin/cohorts'
      fullPath: '/admin/cohorts/'
      preLoaderRoute: typeof AdminCohortsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ranges/$id/soc': {
      id: '/ranges/$id/soc'
      path: '/soc'
      fullPath: '/ranges/$id/soc'
      preLoaderRoute: typeof RangesIdSocRouteImport
      parentRoute: typeof RangesIdRoute
    }
    '/courses/$slug/$module': {
      id: '/courses/$slug/$module'
      path: '/courses/$slug/$module'
      fullPath: '/courses/$slug/$module'
      preLoaderRoute: typeof CoursesSlugModuleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/console/$rangeId/$vmName': {
      id: '/console/$rangeId/$vmName'
      path: '/console/$rangeId/$vmName'
      fullPath: '/console/$rangeId/$vmName'
      preLoaderRoute: typeof ConsoleRangeIdVmNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants_/$tenantId': {
      id: '/admin/tenants_/$tenantId'
      path: '/admin/tenants/$tenantId'
      fullPath: '/admin/tenants/$tenantId'
      preLoaderRoute: typeof AdminTenantsTenantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/cohorts/$id/enroll': {
      id: '/instructor/cohorts/$id/enroll'
      path: '/instructor/cohorts/$id/enroll'
      fullPath: '/instructor/cohorts/$id/enroll'
      preLoaderRoute: typeof InstructorCohortsIdEnrollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses/$id/topic/$topic': {
      id: '/courses/$id/topic/$topic'
      path: '/topic/$topic'
      fullPath: '/courses/$id/topic/$topic'
      preLoaderRoute: typeof CoursesIdTopicTopicRouteImport
      parentRoute: typeof CoursesIdRoute
    }
    '/admin/gradebook/$cohortId/report': {
      id: '/admin/gradebook/$cohortId/report'
      path: '/admin/gradebook/$cohortId/report'
      fullPath: '/admin/gradebook/$cohortId/report'
      preLoaderRoute: typeof AdminGradebookCohortIdReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/gradebook/$cohortId/$userId': {
      id: '/admin/gradebook/$cohortId/$userId'
      path: '/admin/gradebook/$cohortId/$userId'
      fullPath: '/admin/gradebook/$cohortId/$userId'
      preLoaderRoute: typeof AdminGradebookCohortIdUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/cohorts/$id/enroll': {
      id: '/admin/cohorts/$id/enroll'
      path: '/admin/cohorts/$id/enroll'
      fullPath: '/admin/cohorts/$id/enroll'
      preLoaderRoute: typeof AdminCohortsIdEnrollRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface CoursesIdRouteChildren {
  CoursesIdIndexRoute: typeof CoursesIdIndexRoute
  CoursesIdTopicTopicRoute: typeof CoursesIdTopicTopicRoute
}

const CoursesIdRouteChildren: CoursesIdRouteChildren = {
  CoursesIdIndexRoute: CoursesIdIndexRoute,
  CoursesIdTopicTopicRoute: CoursesIdTopicTopicRoute,
}

const CoursesIdRouteWithChildren = CoursesIdRoute._addFileChildren(
  CoursesIdRouteChildren,
)

interface RangesIdRouteChildren {
  RangesIdSocRoute: typeof RangesIdSocRoute
}

const RangesIdRouteChildren: RangesIdRouteChildren = {
  RangesIdSocRoute: RangesIdSocRoute,
}

const RangesIdRouteWithChildren = RangesIdRoute._addFileChildren(
  RangesIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AttackNavigatorRoute: AttackNavigatorRoute,
  BuilderRoute: BuilderRoute,
  CostRoute: CostRoute,
  DevLoginRoute: DevLoginRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LeaderboardRoute: LeaderboardRoute,
  LoginRoute: LoginRoute,
  MonitoringRoute: MonitoringRoute,
  RangeHealthRoute: RangeHealthRoute,
  SettingsRoute: SettingsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminReviewRoute: AdminReviewRoute,
  AdminTenantsRoute: AdminTenantsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  BlueprintsSlugRoute: BlueprintsSlugRoute,
  CoursesIdRoute: CoursesIdRouteWithChildren,
  InstructorOrganizationRoute: InstructorOrganizationRoute,
  InstructorUsersRoute: InstructorUsersRoute,
  JourneyPlacementRoute: JourneyPlacementRoute,
  JourneyResultRoute: JourneyResultRoute,
  LabsIdRoute: LabsIdRoute,
  RangesIdRoute: RangesIdRouteWithChildren,
  ScenariosSlugRoute: ScenariosSlugRoute,
  TraineeRangeIdRoute: TraineeRangeIdRoute,
  AdminIndexRoute: AdminIndexRoute,
  BlueprintsIndexRoute: BlueprintsIndexRoute,
  CoursesIndexRoute: CoursesIndexRoute,
  InstructorIndexRoute: InstructorIndexRoute,
  LabsIndexRoute: LabsIndexRoute,
  RangesIndexRoute: RangesIndexRoute,
  ScenariosIndexRoute: ScenariosIndexRoute,
  TraineeIndexRoute: TraineeIndexRoute,
  AdminTenantsTenantIdRoute: AdminTenantsTenantIdRoute,
  ConsoleRangeIdVmNameRoute: ConsoleRangeIdVmNameRoute,
  CoursesSlugModuleRoute: CoursesSlugModuleRoute,
  AdminCohortsIndexRoute: AdminCohortsIndexRoute,
  AdminGradebookIndexRoute: AdminGradebookIndexRoute,
  InstructorCohortsIndexRoute: InstructorCohortsIndexRoute,
  AdminCohortsIdEnrollRoute: AdminCohortsIdEnrollRoute,
  AdminGradebookCohortIdUserIdRoute: AdminGradebookCohortIdUserIdRoute,
  AdminGradebookCohortIdReportRoute: AdminGradebookCohortIdReportRoute,
  InstructorCohortsIdEnrollRoute: InstructorCohortsIdEnrollRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
